import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import SigninPage from './Signin'
import IdeasPage from './Ideas'
import routes from './routes'
import IdeaPage from './Idea'
import NewIdeaPage from './Ideas/NewIdea'
import db from '../db'
import { ideasState } from '../state'
import { useSetRecoilState, useRecoilState } from 'recoil'
import { sessionState } from '../state'

const App = () => {
  const [session, setSession] = useRecoilState(sessionState)
  const setIdeas = useSetRecoilState(ideasState)

  useEffect(
    () =>
      onAuthStateChanged(getAuth(), resultUser => {
        setSession({
          isAuthenticating: false,
          user: resultUser && {
            uid: resultUser.uid,
            email: resultUser.email,
            displayName: resultUser.displayName
          }
        })
      }),
    [setSession]
  )

  const userId = session.user?.uid
  useEffect(() => {
    if (userId) {
      db.query({
        collection: 'ideas',
        where: ['createdBy', '==', userId],
        orderBy: ['lastUpdatedAt', 'desc']
      }).then(result =>
        setIdeas({
          data: result,
          loading: false
        })
      )
    }
  }, [userId, setIdeas])

  if (session.isAuthenticating) {
    return null
  }

  return (
    <Routes>
      <Route path={routes.signin} element={<SigninPage />} />
      <Route path={routes.newIdea} element={<NewIdeaPage />} />
      <Route path={routes.idea} element={<IdeaPage />} />
      <Route path={routes.ideas} element={<IdeasPage />} />
      <Route path='*' element={<Navigate to={routes.ideas} />} />
    </Routes>
  )
}

export default App
